var _defs, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text10, _text11, _text12, _text13, _text14, _text15, _text16, _text17, _text18, _text19, _text20, _text21, _text22, _text23, _text24, _text25, _text26, _text27, _text28, _text29, _text30, _text31, _text32, _text33, _text34, _text35, _text36, _text37, _text38, _text39, _text40, _text41, _text42, _text43, _text44, _text45, _text46, _text47, _text48;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 536 368",
    className: "fade w-[10rem] md:w-[15rem] lg:w-[20rem]",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "arrow",
    viewBox: "-2 -2 8 8",
    refX: 4,
    refY: 2,
    markerWidth: 7,
    markerHeight: 7,
    orient: "auto-start-reverse"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 0,4 4,2 0,0"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "diamond",
    viewBox: "-2 -2 8 8",
    refX: 4,
    refY: 2,
    markerWidth: 7,
    markerHeight: 7,
    orient: "auto-start-reverse"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,2 2,0 4,2 2,4 0,2"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "circle",
    viewBox: "0 0 8 8",
    refX: 4,
    refY: 4,
    markerWidth: 7,
    markerHeight: 7,
    orient: "auto-start-reverse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 2,
    className: "filled"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "open_circle",
    viewBox: "0 0 8 8",
    refX: 4,
    refY: 4,
    markerWidth: 7,
    markerHeight: 7,
    orient: "auto-start-reverse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 2,
    className: "bg_filled"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "big_open_circle",
    viewBox: "0 0 8 8",
    refX: 4,
    refY: 4,
    markerWidth: 7,
    markerHeight: 7,
    orient: "auto-start-reverse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3,
    className: "bg_filled"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 34,
    y: 28
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "star"
  }, "*"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 522,
    y: 28
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "star"
  }, "*"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 234,
    y: 44
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-1"
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "0000000"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-1"
  }, "11"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "0000"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-1"
  }, "1"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 202,
    y: 60
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-1"
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "000"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-1"
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "00000"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-1"
  }, "11"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "000000000000"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 178,
    y: 76
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "000000"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-1"
  }, "111"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "00000"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-1"
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "0000000000"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-1"
  }, "11"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "000"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 162,
    y: 92
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "00000000"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-1"
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "00000000"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 386,
    y: 92
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "000000"))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 146,
    y: 108
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "0000"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-1"
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "00000000000"))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 418,
    y: 108
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "0000"))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 138,
    y: 124
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "00000"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-1"
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "0000000"))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 124
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "00"))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 442,
    y: 124
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "00"))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 140
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "000"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "0000"))), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 242,
    y: 140
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "00"))), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 458,
    y: 140
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-1"
  }, "1"))), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 156
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-1"
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "000000"))), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 194,
    y: 156
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "00"))), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 218,
    y: 156
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "0000"))), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 122,
    y: 172
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "00"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-1"
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "000000"))), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 234,
    y: 172
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "000"))), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 122,
    y: 188
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "000"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-1"
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "0000000"))), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 218,
    y: 188
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "0000000"))), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 122,
    y: 204
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "00"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-1"
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "0000"))), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 210,
    y: 204
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "0000000000"))), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 122,
    y: 220
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "000000"))), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 178,
    y: 220
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "0"))), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    x: 194,
    y: 220
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "000000"))), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 220
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "000000"))), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 236
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "00"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-1"
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "0000"))), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    x: 202,
    y: 236
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "0000000"))), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 252
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "00000000"))), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    x: 458,
    y: 252
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-1"
  }, "1"))), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    x: 138,
    y: 268
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "00"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-1"
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "000"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-1"
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "000"))), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    x: 442,
    y: 268
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-1"
  }, "1"))), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
    x: 146,
    y: 284
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "000"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-1"
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "000000000000"))), _text36 || (_text36 = /*#__PURE__*/React.createElement("text", {
    x: 418,
    y: 284
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-1"
  }, "11"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "00"))), _text37 || (_text37 = /*#__PURE__*/React.createElement("text", {
    x: 162,
    y: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-1"
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "0000"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-1"
  }, "11"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "000000000"))), _text38 || (_text38 = /*#__PURE__*/React.createElement("text", {
    x: 386,
    y: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "00"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-1"
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "000"))), _text39 || (_text39 = /*#__PURE__*/React.createElement("text", {
    x: 178,
    y: 316
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "000000000"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-1"
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "00000000"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-1"
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "000000"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-1"
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "0000"))), _text40 || (_text40 = /*#__PURE__*/React.createElement("text", {
    x: 202,
    y: 332
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-1"
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "0000000"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-1"
  }, "11"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "00000"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-1"
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "00000000"))), _text41 || (_text41 = /*#__PURE__*/React.createElement("text", {
    x: 234,
    y: 348
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "000"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-1"
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "0000000000"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-1"
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    className: "tspan-0"
  }, "0"))), _text42 || (_text42 = /*#__PURE__*/React.createElement("text", {
    x: 482,
    y: 44
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "star"
  }, "*"))), _text43 || (_text43 = /*#__PURE__*/React.createElement("text", {
    x: 2,
    y: 140
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "star"
  }, "*"))), _text44 || (_text44 = /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 172
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "star"
  }, "*"))), _text45 || (_text45 = /*#__PURE__*/React.createElement("text", {
    x: 522,
    y: 188
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "star"
  }, "*"))), _text46 || (_text46 = /*#__PURE__*/React.createElement("text", {
    x: 498,
    y: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "star"
  }, "*"))), _text47 || (_text47 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 316
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "star"
  }, "*"))), _text48 || (_text48 = /*#__PURE__*/React.createElement("text", {
    x: 178,
    y: 348
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "star"
  }, "*"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c57c409ecaaefab14f5c39d97b22966c.svg";
export { ForwardRef as ReactComponent };